import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {extendObservable, computed, runInAction} from "mobx";
import axios from 'axios';
import {Provider} from "mobx-react";
import hello from 'hellojs';
import jwt_decode from 'jwt-decode';

class MainApi {

  constructor() {
    this.host = 'https://omg.ministryofcoin.com'; //'http://localhost:3001';
  }
  fetchFundStatus = (auth_token) => {
    return axios.get(this.host+'/fund/status', auth_token ? {
      headers: { Authorization: "Bearer " + auth_token }
    } : null);
  }
  signFundContract = (id, auth_token) => {
    return axios.post(this.host+'/fund/sign', {
      id
    }, auth_token ? {
      headers: { Authorization: "Bearer " + auth_token }
    } : null);
  }
  fetchExchangeCurrencies = () => {
    return axios.get(this.host+'/exchange/currencies');
  }
  fetchMinimumAmount = (from, to) => {
    return axios.get(this.host+'/exchange/minimum/'+from+"/"+to);
  }
  fetchConversionAmount = (from, to, from_amount) => {
    return axios.get(this.host+'/exchange/convert/'+from+"/"+to+"/"+from_amount);
  }
  fetchTrxStatus = (trx_id, auth_token) => {
    return axios.get(this.host+'/exchange/transaction/'+trx_id, auth_token ? {
      headers: { Authorization: "Bearer " + auth_token }
    } : null);
  }
  fetchDeliveryEstimate = (from, to) => {
    return axios.get(this.host+'/exchange/estimate/'+from+"/"+to);
  }
  validateAddress = (currency, address, extra) => {
    return axios.get(this.host+'/exchange/validate/'+currency+"/"+address+(extra ? "/"+extra : ''));
  }
  initiateTransaction = (from, to, from_amount, to_amount, address, metadata, auth_token) => {
    return axios.post(this.host+'/exchange/transaction/', {
      from, to, from_amount, to_amount, address, metadata
    }, auth_token ? {
      headers: { Authorization: "Bearer " + auth_token }
    } : null);
  }
  authenticate = (network, socialToken) => {
    return axios.post(this.host+'/auth/token', {
      network, socialToken
    });
  }
  // market
  fetchMarketTop10 = () => {
    return axios.get(this.host+'/market/top10');
  }
}

class MainStore {

  constructor(theApi) {
    extendObservable(this, {
      show_login_modal: false,
      auth_token: localStorage.getItem('auth_token'),
      auth_user: computed(function() {
        if(!this.auth_token) return null;
        return jwt_decode(this.auth_token);
      }),
      authenticated: computed(function() {
        return !!this.auth_token;
      }),
      marketTop10: [],
      location: '/'
    })
    this.theApi = theApi;
    this.hello = hello.init({
      "facebook": '501271383606855'
    }, {
      scope: 'email',
      redirect_uri: '/__utils/redirect.html'
    });
    this.fetchMarketTop10();
  }

  validateAddress = async(currency, address, metadata) => {
    return await this.theApi.validateAddress(currency, address, metadata).then((response) => {
      return response.data.result
    })
  }

  fetchExchangeCurrencies = async () => {
    return await this.theApi.fetchExchangeCurrencies().then((response) => {
      return response.data.result
    })
  }

  fetchMinimumAmount = async (from, to) => {
    return await this.theApi.fetchMinimumAmount(from, to).then((response) => {
      return response.data.result
    })
  }

  fetchConversionAmount = async (from, to, from_amount) => {
    return await this.theApi.fetchConversionAmount(from, to, from_amount).then((response) => {
      return response.data.result
    })
  }

  fetchTrxStatus = async (trx_id) => {
    return await this.theApi.fetchTrxStatus(trx_id, this.auth_token).then((response) => {
      return response.data.result
    });
  }

  fetchDeliveryEstimate = async(from, to) => {
    return await this.theApi.fetchDeliveryEstimate(from, to).then((response) => {
      return response.data.result
    })
  }

  initiateTransaction = async (from, to, from_amount, to_amt, address, metadata) => {
    return await this.theApi.initiateTransaction(from, to, from_amount, to_amt, address, metadata, this.auth_token).then((response) => {
      return response.data.result
    });
  }

  fetchFundStatus = async () => {
    return await this.theApi.fetchFundStatus(this.auth_token).then((response) => {
      return response.data.result
    });
  }

  signFundContract = async (id) => {
    return await this.theApi.signFundContract(id, this.auth_token).then((response) => {
      return response.data.result
    });
  }

  fetchMarketTop10 = async() => {
    return await this.theApi.fetchMarketTop10().then((response) => {
      runInAction(() => {
        this.marketTop10 = response.data.result
      })
    });
  }

  auth = async (network) => {
    this.hello.login(network).then((auth) => {
      let socialToken = auth.authResponse.access_token;
      this.theApi.authenticate(auth.network, socialToken).then((t) => {
        this.auth_token = t.data.result;
        localStorage.setItem('auth_token', this.auth_token);
        this.hello(auth.network).logout();
      });
    }, function(e) {
    	alert('Signin error: ' + e.error.message);
    })
    this.show_login_modal = false;
  }

  login = async () => {
    this.show_login_modal = true;
  }

  logout = async () => {
    this.auth_token = null;
    localStorage.removeItem('auth_token');
  }

}

const api = new MainApi();
const store = new MainStore(api);

ReactDOM.render(<Provider main={store}><Router><App /></Router></Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js